@if (open) {
    <div class="overlay" (mousedown)="backdropClick($event)">
        <section #dialog class="dialog" role="dialog" aria-modal="true" [attr.aria-label]="title || 'Slides'" tabindex="-1"
            [style.--accent]="currentSlide?.colour || null">
            <header class="header">
                <div class="heading">
                    @if (title) { <h2>{{ title }}</h2> }
                    @if (subtitle) { <p [innerHTML]="subtitle"></p> }
                </div>
                @if (slides.length) {
                    <span class="count" aria-live="polite">{{ index + 1 }} of {{ slides.length }}@if (currentSlide?.title) {<span class="visually-hidden">: {{ currentSlide?.title }}</span>}</span>
                }
                <button mat-icon-button class="close" type="button" aria-label="Close" matTooltip="Close (Esc)" (click)="close()">
                    <mat-icon>close</mat-icon>
                </button>
            </header>
            <div class="progress" aria-hidden="true"><span [style.width.%]="progress"></span></div>

            <div class="content">
                <button mat-icon-button class="nav" type="button" aria-label="Previous slide" matTooltip="Previous (←)" (click)="prev()" [disabled]="atStart">
                    <mat-icon>chevron_left</mat-icon>
                </button>

                <div class="viewport">
                    <!-- the slide is made again for each one shown, so it slides in from the side it comes from -->
                    @for (slide of [currentSlide]; track index) {
                        @if (slide) {
                            <div class="slide" [class.forward]="direction === 'forward'" [class.backward]="direction === 'backward'">
                                @if (slide.template) {
                                    <ng-container *ngTemplateOutlet="slide.template; context: { $implicit: slide.data, index: index }"></ng-container>
                                } @else if (slide.imageUrl) {
                                    <figure class="figure">
                                        <img [src]="slide.imageUrl" [alt]="slide.alt || ''" />
                                        @if (slide.caption) { <figcaption>{{ slide.caption }}</figcaption> }
                                    </figure>
                                } @else {
                                    <div class="empty">There's nothing to show on this slide.</div>
                                }
                            </div>
                        }
                    }
                </div>

                <button mat-icon-button class="nav" type="button" aria-label="Next slide" matTooltip="Next (→)" (click)="next()" [disabled]="atEnd">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>

            @if (showDots && slides.length > 1) {
                <nav class="footer" aria-label="Slides">
                    @for (s of slides; let i = $index; track i) {
                        @if (s.title) {
                            <button class="chip" type="button" [class.active]="i === index" [attr.aria-current]="i === index ? 'true' : null"
                                [style.--chip]="s.colour || null" (click)="goTo(i)">{{ s.title }}</button>
                        } @else {
                            <button class="dot" type="button" [class.active]="i === index" [attr.aria-current]="i === index ? 'true' : null"
                                (click)="goTo(i)" [attr.aria-label]="'Go to slide ' + (i + 1)"></button>
                        }
                    }
                </nav>
            }
        </section>
    </div>
}
